import { render, staticRenderFns } from "./liqBtn.vue?vue&type=template&id=5fa31952&scoped=true&"
import script from "./liqBtn.vue?vue&type=script&lang=js&"
export * from "./liqBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa31952",
  null
  
)

export default component.exports